import { css } from "@conectate/components/ct-lit";

/**
 * @cssprop {number} --zi-stickys
 * @cssprop {number} --zi-app-bar
 *
 */
let defaultTheme = css`
	:root {
		/* Fondos */
		--color-background: #eef3fa;
		--color-background-rgb: 238, 243, 250;
		/* Fondos Textos que aparecen en los fondos */
		--color-on-background: #4b5565; /* Gris */
		--color-on-background-rgb: 75, 85, 101;

		/* Fondos que estan en cima de los fondos (ct-cards) */
		--color-surface: #ffffff;
		--color-surface-rgb: 255, 255, 255;
		--color-surface-bright: #ffffff;
		--color-surface-dim: #f3f3f3;
		--color-surface-variant: #eef0f4;
		/* Fondos Textos que aparecen en los ct-cards */
		--color-on-surface: #4b5565; /* Gris */
		--color-on-surface-rgb: 75, 85, 101;

		/* Color de objeto en cima de error */
		--color-error: #9f1239;
		--color-error-container: #9f123a3a;
		--color-on-error: #fff;

		--high-emphasis: #121926f5;
		--medium-emphasis: #12192699;
		--color-disable: #12192647;

		--font-title: "Google Sans", "Ubuntu", arial, sans-serif;

		/* Blur */
		--color-blur-surface: rgba(255, 255, 255, 0.6);
		--color-on-surface-opaque: #8e8e8e; /* Texto sencundarios */
		--color-outline: #7c7c7c30; /* divisores */
		--menu-outline: 1px solid var(--color-outline);
		--color-menu: #f8f9fb;

		--blue: #2674fc;
		--blue-medium: #2674fcb0;
		--blue-light: #2674fc2b;

		--green: #10b981;
		--green-medium: #10b981b0;
		--green-light: #10b9812b;

		--yellow: #d97706;
		--yellow-medium: #f4bb0ab0;
		--yellow-light: #fef3c7;

		--violet: #8a12f4;
		--medium-violet: #9013feb0;
		--light-violet: #9013fe2b;

		--zi-stickys: 70;
		--zi-menus: 80;
		--zi-app-bar: 90;
		--zi-drawer: 100;
		--zi-modal: 110;
		--zi-snackbar: 150;
		--zi-tooltip: 150;
		--cursor-close-svg-url: url(/static/img/icons/cursor-close.svg);
	}
	@media only screen {
		.dark {
			/* Fondos */
			--color-background: #111e23;
			--color-background-rgb: 17, 30, 35;
			/* Fondos Textos que aparecen en los fondos */
			--color-on-background: #eaeaea;
			--color-on-background-rgb: 234, 234, 234;

			/* Fondos que estan en cima de los fondos (ct-cards) */
			--color-surface: #1f353e;
			--color-surface-rgb: 31, 53, 62;
			--color-surface-bright: #284450;
			--color-surface-dim: #17272d;
			--color-surface-variant: #17272d;
			/* Fondos Textos que aparecen en los ct-cards */
			--color-on-surface: #eaeaea;
			--color-on-surface-rgb: 234, 234, 234;

			--color-error: #cf6679;
			--color-on-error: #fff;

			--high-emphasis: #ffffffde;
			--medium-emphasis: #ffffff99;
			--color-disable: #ffffff61;

			--color-on-surface-opaque: #8e8e8e; /* Texto sencundarios */
			--color-outline: #bbbbbb24; /* divisores */
			--color-blur-surface: #1a2c34b3;
			--menu-outline: 1px solid var(--color-outline);
			--color-menu: #30505e;

			--blue: #2674fc;
			--blue-medium: #2674fcb0;
			--blue-light: #2674fc2b;

			--green: #04d29f;
			--green-medium: #04d29fb0;
			--green-light: #04d29f2b;

			--yellow: #d97706;
			--yellow: #f4bb0a;
			--yellow-medium: #f4bb0ab0;
			--yellow-light: #f4ba0a1f;

			--violet: #8a12f4;
			--medium-violet: #9013feb0;
			--light-violet: #9013fe2b;
		}
	}

	:root {
		/*
		* Gradients
		*/
		--employ-one: linear-gradient(-45deg, #2084e8, #862efb);
		--c2-grad-blue: linear-gradient(315deg, #6949c5, #20c0cb);
		--c2-grad-orange: linear-gradient(315deg, #fd183c, #ff6326);
		--c2-grad-rose-orange: linear-gradient(315deg, #ff0e83, #ff6050);
		--c2-grad-purple1: linear-gradient(315deg, #843ef6, #3469e7);
		--c2-grad-purple: linear-gradient(269deg, #8e43e6, #cb15ac);
		--c2-grad-green: linear-gradient(284deg, #0fb8ad, #23ef51);
		--c2-grad-lime: linear-gradient(90deg, #5bd0f6, #dcf921);
		--c2-grad-fb2: linear-gradient(80deg, #00aeff, #0060df);
		--c2-grad-circle: linear-gradient(160deg, #0089d9, #50fff5);
		--c2-grad-fb: linear-gradient(90deg, #3779f3, #2e40dd);
		--c2-grad-s: linear-gradient(150deg, #53f, #05d5ff, #a6ffcb);
		--c2-grad-light-blue: linear-gradient(315deg, rgba(44, 181, 232, 0.86), rgba(32, 192, 203, 0.86));

		/**
		* Shadows
		*/
		--c2-shadow-card: 0 2px 8px 1px rgba(0, 0, 0, 0.3);
		--c2-shadow-red: 0 2px 8px 1px rgba(190, 0, 100, 0.3);
		--c2-shadow-card-1: 0 2px 8px 1px rgba(0, 0, 0, 0.1);
		--c2-shadow-blue: 0 2px 16px 4px rgba(99, 188, 240, 0.35);
	}
	/* EXTRASSS ======== */
	html,
	body {
		margin: 0;
		padding: 0;
		font-size: 14px;
		min-height: 100vh;
		min-height: 100dvh;
		background: var(--color-background);
		color: var(--color-on-background);
		font-family: "Roboto", sans-serif !important;
	}

	.overflow-hidden {
		overflow: hidden;
	}
	.body::-webkit-scrollbar {
		width: 9px;
	}

	.body::-webkit-scrollbar-track {
		border-radius: 8px;
	}

	.body::-webkit-scrollbar-thumb {
		background-color: var(--color-primary);
		outline: 1px solid slategrey;
		border-radius: 8px;
		outline: none;
		border: none;
	}
	@media print {
		/* :root {
			--color-background: #ffff;
		} */
		@page {
			/* size: letter; */
			scale: 10%;
			margin: 0.6cm;
			/* height: 216mm; */
			/* width: 300mm; */
		}

		body,
		html {
			-webkit-print-color-adjust: exact !important;
			height: auto !important;
			max-height: none !important;
			background: #fff !important;
			position: unset;
		}
		.firebase-emulator-warning,
		.react-flow__attribution {
			display: none !important;
		}
	}

	:root {
		--md-sys-color-primary: var(--color-primary);
		--md-sys-color-on-primary: var(--color-on-primary);
		--md-sys-color-primary-container: var(--color-primary-container);
		--md-sys-color-on-primary-container: var(--color-on-primary-container);
		--md-sys-color-secondary: var(--color-primary);
		--md-sys-color-on-secondary: var(--color-on-secondary);
		--md-sys-color-surface: var(--color-surface);
		--md-sys-color-on-surface: var(--color-on-surface);
		--md-sys-color-on-surface-variant: var(--color-on-surface);
		--md-sys-color-surface-container: var(--color-surface-container, var(--color-surface));
		--md-sys-color-outline-variant: var(--color-outline);
		/* Esto es para el color del md-slider */
		--md-sys-color-surface-container-highest: var(--color-outline);

		--border-radius: 24px;
		--md-menu-container-shape: 16px;
		--md-menu-container-color: var(--color-menu);
		--ct-card-box-shadow: none;
		--color-blur: var(--color-blur-surface);
	}
	@keyframes fade-in {
		from {
			opacity: 0;
		}
	}

	@keyframes fade-out {
		to {
			opacity: 0;
		}
	}

	@keyframes slide-from-right {
		from {
			transform: translateX(30px);
		}
	}

	@keyframes slide-to-left {
		to {
			transform: translateX(-30px);
		}
	}

	::view-transition-old(root) {
		animation:
			90ms cubic-bezier(0.4, 0, 1, 1) both fade-out,
			300ms cubic-bezier(0.4, 0, 0.2, 1) both slide-to-left;
	}

	::view-transition-new(root) {
		animation:
			210ms cubic-bezier(0, 0, 0.2, 1) 90ms both fade-in,
			300ms cubic-bezier(0.4, 0, 0.2, 1) both slide-from-right;
	}

	.employone {
		--color-primary: #2084e8;
		--color-secondary: #862efb;
		--color-secondary: #2084e8;
		--color-secondary: #862efb;
		--color-primary-medium: #2084e8b0;
		--color-primary-light: #2084e82b;

		--color-app: linear-gradient(-45deg, #2084e8, #862efb);
		--color-background: #ffffff;
	}
	.introjs-tooltip-title {
		font-family: "Google Sans", "Ubuntu", "Roboto", sans-serif;
		color: var(--color-primary, #00aeff);
	}
	.introjs-button {
		font-family: "Google Sans", "Ubuntu", "Roboto", sans-serif;
		padding: 0.6em 1.7em;
		border-radius: 26px;
		color: var(--color-primary, #00aeff);
		transition:
			background-color 200ms,
			box-shadow 350ms;
		border: 1px solid rgba(128, 128, 128, 0.31);
		background-color: transparent;
		font-weight: bold;
		cursor: pointer;
	}
	.introjs-nextbutton,
	.introjs-nextbutton:hover .introjs-nextbutton:active .introjs-nextbutton:focus {
		background: var(--color-primary, #00aeff) !important;
		color: #fff !important;
		border: none !important;
		text-shadow: none;
	}
	.introjs-nextbutton:hover .introjs-nextbutton:active .introjs-nextbutton:focus {
		box-shadow: var(--ct-button-box-shadow, 0 2px 16px 4px rgba(99, 188, 240, 0.45)) !important;
	}

	.introjs-helperLayer {
		background-color: #fff0 !important;
		border-radius: var(--border-radius, 16px);
		box-shadow:
			#28bcc1cc 0px 0px 1px 2px,
			#1e4e69cc 0px 0px 0px 5000px !important;
		/* border: 4px solid var(--color-on-background);
		 */
	}
	.introjs-tooltip {
		background-color: var(--color-background) !important;
		color: var(--color-on-background);
	}
	.introjs-skipbutton {
		color: var(--color-on-background) !important;
	}

	.introjs-tooltipbuttons {
		border-top: none;
	}
	.introjs-arrow.left {
		border-right-color: var(--color-background);
	}
	.firebase-emulator-warning,
	.react-flow__attribution {
		display: none;
		font-size: 10px;
	}
`;

export function addCSS(src: string) {
	const link = document.createElement("link");
	link.rel = "stylesheet";
	link.type = "text/css";
	link.href = src;
	document.head.appendChild(link);
}
export function addFont(family: string, css = "css") {
	const link = document.createElement("link");
	link.rel = "stylesheet";
	link.type = "text/css";
	link.href = `https://fonts.googleapis.com/${css}?family=${family}&display=swap`;
	document.head.appendChild(link);
}
export function inyectStyles(params: { css?: string; id?: string; replace?: boolean } = {}) {
	const style = document.createElement("style");
	style.id = params.id || "ctStyles";
	style.innerHTML = params.css || defaultTheme.toString();
	let styleRef = document.getElementById(style.id);
	if (!styleRef) document.head.appendChild(style);
	else if (params.replace) styleRef.innerHTML = params.css || defaultTheme.toString();
}

export function applyDefaultTheme(params: { css?: string; id?: string } = {}, fonts = true) {
	if (fonts) {
		addCSS(`https://unpkg.com/intro.js/minified/introjs.min.css`);
		addFont(`Ubuntu:400,500,700`);
		addFont(`Roboto:400,500,700`);
		if (process.env.NODE_ENV == "development") {
			import("@conectate/components/ct-icon").then(m => (m.CtIcon.ready = true));
			addCSS("/static/fonts/material-icons.css");
		}
		// addFont(`Material+Icons+Round`);
		// addFont(`Google+Sans:400,500,700`);
		// addFont(`Product+Sans:400,500,700`);
	}
	inyectStyles({ css: params.css || defaultTheme.toString(), id: params.id || "root_styles" });
	window.app.localStorage.theme == "dark" && document.documentElement.classList.add("dark");
}

export class Theme {
	static listeners: ((theme: "dark" | "light" | "full-dark") => any)[] = [];
	static on(s: "change", listener: (theme: "dark" | "light" | "full-dark") => any) {
		switch (s) {
			case "change":
				Theme.listeners.push(listener);
				return () => (Theme.listeners = Theme.listeners.filter(_ => _ != listener));
		}
	}

	static remove(s: "change", listener: (theme: string) => any) {
		switch (s) {
			case "change":
				Theme.listeners = Theme.listeners.filter(_ => _ != listener);
		}
	}

	static toggle() {
		let currentTheme: "dark" | "light" | "full-dark" = document.documentElement.classList.value as "dark" | "light" | "full-dark";

		if (currentTheme.includes("dark")) {
			window.app.localStorage.theme = "light";
			document.documentElement.classList.remove("dark");
			document.documentElement.classList.remove("full-dark");
			Theme.listeners.forEach(_ => _("light"));
		} else {
			let apply: "dark" | "light" | "full-dark" = "dark";
			if (window.webkit?.messageHandlers.swift) apply = "full-dark";
			window.app.localStorage.theme = apply;
			document.documentElement.classList.add(apply);
			Theme.listeners.forEach(_ => _(apply));
		}
	}
	static setTheme(color: "dark" | "light" | "full-dark", persist = true) {
		if (window.webkit?.messageHandlers.swift && color == "dark") {
			color = "full-dark";
		}
		if (color == "dark") {
			if (persist) localStorage.theme = "dark";
			document.documentElement.classList.add("dark");
			document.documentElement.classList.remove("full-dark");
			Theme.listeners.forEach(_ => _("dark"));
		} else if (color == "full-dark") {
			if (persist) localStorage.theme = "full-dark";
			document.documentElement.classList.add("full-dark");
			document.documentElement.classList.remove("dark");
			Theme.listeners.forEach(_ => _("full-dark"));
		} else {
			if (persist) localStorage.theme = "light";
			document.documentElement.classList.remove("dark");
			document.documentElement.classList.remove("full-dark");
			Theme.listeners.forEach(_ => _("light"));
		}
	}

	static getTheme() {
		return window.app.localStorage.theme || "light";
	}
}

declare global {
	interface Window {
		Theme: Theme;
	}
}
window.Theme = Theme;
